"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LineString = _interopRequireDefault(require("../../../geom/LineString"));

var _CoordinateList = _interopRequireDefault(require("../../../geom/CoordinateList"));

var _Coordinate = _interopRequireDefault(require("../../../geom/Coordinate"));

var _Double = _interopRequireDefault(require("../../../../../../java/lang/Double"));

var _LineSegment = _interopRequireDefault(require("../../../geom/LineSegment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LineStringSnapper =
/*#__PURE__*/
function () {
  function LineStringSnapper() {
    _classCallCheck(this, LineStringSnapper);

    LineStringSnapper.constructor_.apply(this, arguments);
  }

  _createClass(LineStringSnapper, [{
    key: "snapVertices",
    value: function snapVertices(srcCoords, snapPts) {
      var end = this._isClosed ? srcCoords.size() - 1 : srcCoords.size();

      for (var i = 0; i < end; i++) {
        var srcPt = srcCoords.get(i);
        var snapVert = this.findSnapForVertex(srcPt, snapPts);

        if (snapVert !== null) {
          srcCoords.set(i, new _Coordinate.default(snapVert));
          if (i === 0 && this._isClosed) srcCoords.set(srcCoords.size() - 1, new _Coordinate.default(snapVert));
        }
      }
    }
  }, {
    key: "findSnapForVertex",
    value: function findSnapForVertex(pt, snapPts) {
      for (var i = 0; i < snapPts.length; i++) {
        if (pt.equals2D(snapPts[i])) return null;
        if (pt.distance(snapPts[i]) < this._snapTolerance) return snapPts[i];
      }

      return null;
    }
  }, {
    key: "snapTo",
    value: function snapTo(snapPts) {
      var coordList = new _CoordinateList.default(this._srcPts);
      this.snapVertices(coordList, snapPts);
      this.snapSegments(coordList, snapPts);
      var newPts = coordList.toCoordinateArray();
      return newPts;
    }
  }, {
    key: "snapSegments",
    value: function snapSegments(srcCoords, snapPts) {
      if (snapPts.length === 0) return null;
      var distinctPtCount = snapPts.length;
      if (snapPts[0].equals2D(snapPts[snapPts.length - 1])) distinctPtCount = snapPts.length - 1;

      for (var i = 0; i < distinctPtCount; i++) {
        var snapPt = snapPts[i];
        var index = this.findSegmentIndexToSnap(snapPt, srcCoords);

        if (index >= 0) {
          srcCoords.add(index + 1, new _Coordinate.default(snapPt), false);
        }
      }
    }
  }, {
    key: "findSegmentIndexToSnap",
    value: function findSegmentIndexToSnap(snapPt, srcCoords) {
      var minDist = _Double.default.MAX_VALUE;
      var snapIndex = -1;

      for (var i = 0; i < srcCoords.size() - 1; i++) {
        this._seg.p0 = srcCoords.get(i);
        this._seg.p1 = srcCoords.get(i + 1);

        if (this._seg.p0.equals2D(snapPt) || this._seg.p1.equals2D(snapPt)) {
          if (this._allowSnappingToSourceVertices) continue;else return -1;
        }

        var dist = this._seg.distance(snapPt);

        if (dist < this._snapTolerance && dist < minDist) {
          minDist = dist;
          snapIndex = i;
        }
      }

      return snapIndex;
    }
  }, {
    key: "setAllowSnappingToSourceVertices",
    value: function setAllowSnappingToSourceVertices(allowSnappingToSourceVertices) {
      this._allowSnappingToSourceVertices = allowSnappingToSourceVertices;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return LineStringSnapper;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "isClosed",
    value: function isClosed(pts) {
      if (pts.length <= 1) return false;
      return pts[0].equals2D(pts[pts.length - 1]);
    }
  }]);

  return LineStringSnapper;
}();

exports.default = LineStringSnapper;

LineStringSnapper.constructor_ = function () {
  this._snapTolerance = 0.0;
  this._srcPts = null;
  this._seg = new _LineSegment.default();
  this._allowSnappingToSourceVertices = false;
  this._isClosed = false;

  if (arguments[0] instanceof _LineString.default && typeof arguments[1] === "number") {
    var srcLine = arguments[0],
        snapTolerance = arguments[1];
    LineStringSnapper.constructor_.call(this, srcLine.getCoordinates(), snapTolerance);
  } else if (arguments[0] instanceof Array && typeof arguments[1] === "number") {
    var srcPts = arguments[0],
        _snapTolerance = arguments[1];
    this._srcPts = srcPts;
    this._isClosed = LineStringSnapper.isClosed(srcPts);
    this._snapTolerance = _snapTolerance;
  }
};